"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Alexa(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M11.957 2C6.457 2 2 6.46 2 11.962a9.962 9.962 0 0 0 8.63 9.873v-2.007a1.32 1.32 0 0 0-.894-1.255 6.975 6.975 0 0 1-4.747-6.78 6.947 6.947 0 0 1 7.04-6.804 6.972 6.972 0 0 1 6.892 7.233l-.002.058-.015.24-.007.076a6.464 6.464 0 0 1-.04.353l-.012.084c-.854 5.624-8.175 8.785-8.215 8.802.434.058.877.088 1.327.088 5.499 0 9.956-4.46 9.956-9.961C21.913 6.46 17.456 2 11.957 2", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Alexa;
